export const styles = {
	textField: {
		'& .MuiOutlinedInput-root': {
			'& .MuiOutlinedInput-notchedOutline': {
				borderColor: 'black',
				opacity: '23%',
			},
		},
		'& .MuiInputBase-input': {
			boxSizing: 'content-box',
			height: '100%',
		},
	},
	chip: {
		paddingX: '0.5rem',
		color: 'black',
	},
	inputLabel: {
		color: 'black',
		opacity: '23%',
	},
	sideBar: {
		display: { xs: 'none', sm: 'block' },
		minWidth: '4px',
		marginRight: '2rem',
		background: 'linear-gradient(180deg, #F84BB2 0%, #FC6767 100%)',
	},
	header: {
		marginY: '2rem',
	},
	container: {
		display: 'flex',
	},
	inputContainer: {
		display: 'flex',
		flexDirection: 'column',
		rowGap: '3rem',
		flexGrow: '1',
	},
	buttonRow: {
		display: 'flex',
		flexDirection: 'row',
		gap: '2rem',
	},
}
